import React from 'react';
import { Button } from './ui/button';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle = ({ className = "", size = "sm", variant = "outline" }) => {
  const { toggleTheme, getThemeIcon, getThemeTooltip } = useTheme();

  const getIcon = () => {
    const iconType = getThemeIcon();
    switch (iconType) {
      case 'sun':
        return <Sun className="h-4 w-4" />;
      case 'moon':
        return <Moon className="h-4 w-4" />;
      default:
        return <Sun className="h-4 w-4" />;
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={toggleTheme}
      className={`flex items-center gap-2 flex-shrink-0 hover:bg-accent transition-colors ${className}`}
      title={getThemeTooltip()}
    >
      {getIcon()}
    </Button>
  );
};

export default ThemeToggle;
